export { default } from './UserRoomViewContainer';



// WEBPACK FOOTER //
// ./src/components/Messenger/containers/UserRoomViewContainer/index.js